import api from "api";
import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { SetInitiative } from "store/dispatcher";
import stateMap from "store/stateMap";
import { RatingsList } from "component/Rating";
import BlockHeader from "component/BlockHeader/BlockHeader";
import _ from "lodash"
;
import "./index.scss";
import { PageCredential } from "component/PageCredential";

const PageInsideInitiativeTalk = connect( stateMap, {SetInitiative} )((props) => {
    const [admins, setAdmins]   = useState(false);
    const [roles, setRoles]     = useState(false);

    useEffect(() => {
        if(props.auth.user && props.initiative.initiative && props.initiative.initiative.CurrentStatus == 'rating')
        {
            api('/Role', 'get', {
                initiative_id : props.initiative.initiative.InitiativeID
            }, 'Bearer ' + props.auth.token)
                .then((response) => {
                    setRoles(_.map(response.roles, (role) => {
                        role.queryparams = {
                            role_id : role.RoleID
                        };

                        return role;
                    } ));
                });
        }
    }, [props.initiative.initiative, props.auth.user])

    return (
        props.initiative.initiative.CurrentStatus == 'rating' && props.initiative.access.membership &&
        <div className="initiative-inside-rating container">
            <PageCredential title={`${props.initiative.initiative.Title} | Rating`} />
            <BlockHeader title="Peer Rating" desc="Give a sincere assessment of your co-workers, all ratings and testimonials will appear anonymously"/>
            <div className="role-lists">
                <div className="role-list -role-list-admins">
                    <div className="wrapper">
                        <h1 className="role-name text-md mb-sm">Initiator &amp; Co-Creator</h1>
                        <RatingsList 
                            sourceId={props.initiative.initiative.InitiativeID}
                            sourceType="as-admin" 
                            postsPerPage="10"
                            token={props.auth.token} 
                            currentUser={props.auth.user}
                        />
                    </div>
                </div>
                {
                    roles !== false && roles.map((role) => (
                        <div className="role-list" key={role.RoleID}>
                            <div className="wrapper">
                                <h1 className="role-name text-md mb-sm">{role.RoleName}</h1>
                                <RatingsList 
                                    sourceId={role.RoleID}
                                    sourceType="as-contributor" 
                                    postsPerPage="50"
                                    token={props.auth.token}  
                                    currentUser={props.auth.user}
                                />
                            </div>
                        </div>
                    ))
                }
                {
                    roles === false && 
                    <span className="text-center font-italic text-xs block mt-md mb-md">Loading Roles..</span>
                }
            </div>
        </div>
    )
});

export default PageInsideInitiativeTalk;